import { makeDialog } from '@cast/design-system';

import {
  DeleteChildOrganizationDialogContent,
  DeleteChildOrganizationDialogProps,
} from './DeleteChildOrganizationDialog';

export const useDeleteChildOrganizationDialog =
  makeDialog<DeleteChildOrganizationDialogProps>(
    DeleteChildOrganizationDialogContent
  );
